import React from 'react';
import { Save, LibraryAdd } from '@mui/icons-material';
import { observer, useLocalObservable } from 'mobx-react-lite';
import ButtonComponent from '../../../component/button/button.component';
import DialogComponent from '../../../component/dialog/dialog.component';
import RestaurantInfo, { RestaurantInfoCardConfig } from './restaurant-info';
import { RestaurantInfoState } from './restaurant-info-state';
import { RestaurantManageState } from './restaurant-managet-state';
import RestaurantExtensionsDialog from './restaurant-extensions';
import DeleteDialog from '../../../component/dialog/delete-dialog.component';
import ResellerGYBDialog from './restaurant-reseller-gyb';
import BindAccount from '../../../component/bind-account/bind-account.component';
import RestaurantCoreFlieLogDialog from './restaurant-core-file-log';
import i18n from '../../../i18n';
import { useTranslation } from 'react-i18next';
import PdfPreviewDialog from '../../../component/pdf-preview-dialog';

export default observer(function RestaurantDialog(props: { RestaurantManageData: RestaurantManageState }) {
    useTranslation();
    const { isShowRestaurantDialog, restaurantId, dialogComponentType } = props.RestaurantManageData;

    const restaurantInfoState = useLocalObservable(() => new RestaurantInfoState({
        componentType: dialogComponentType,
        restaurantId
    }));

    React.useEffect(() => {
        if (isShowRestaurantDialog === true) {
            restaurantInfoState.updateComponentType(dialogComponentType);
            restaurantInfoState.updateRestaurantId(restaurantId || '');
        }
    }, [isShowRestaurantDialog])
    return (
        <DialogComponent
            open={isShowRestaurantDialog}
            onClose={() => {
                props.RestaurantManageData.showRestaurantDialog(false);
            }}
            fullWidth
            defaultHeaderProps={
                {
                    title: i18n.t('restaurant_management_page'),
                    rightNode: (
                        <>
                            <ButtonComponent
                                variant='outlined'
                                handleClick={async () => {
                                    const res = await restaurantInfoState.onSave();
                                    if (res) {
                                        props.RestaurantManageData.showRestaurantDialog(false);
                                        props.RestaurantManageData.init();
                                    }
                                }}
                                titleText={i18n.t('general_text_save')}
                            >
                                <Save className='iconColor' />
                            </ButtonComponent>
                            {restaurantInfoState.componentType === 'ADD'
                                && <ButtonComponent
                                    variant='outlined'
                                    buttonStyle={{ marginLeft: '1rem' }}
                                    handleClick={async () => {
                                        const res = await restaurantInfoState.onSave();
                                        if (res) {
                                            props.RestaurantManageData.init();
                                        }
                                    }}
                                    titleText={i18n.t('general_text_save_and_update')}
                                >
                                    <LibraryAdd />
                                </ButtonComponent>}
                        </>
                    )
                }
            }
        >
            <RestaurantInfo
                restaurantInfoState={restaurantInfoState}
                RestaurantInfoCardConfig={RestaurantInfoCardConfig}
            />
            {/* 餐厅扩展功能信息（密钥） */}
            <RestaurantExtensionsDialog
                open={restaurantInfoState.showExtensionsDialog.open}
                onClose={() => restaurantInfoState.showExtensionsDialog.onClose()}
                secretKey={restaurantInfoState.showExtensionsDialog.secretKey}
                onSave={async (params) => await restaurantInfoState.showExtensionsDialog.onSave?.(params)}
                dialogType={restaurantInfoState.showExtensionsDialog.dialogType}
            />
            {/* 二次确认弹窗 */}
            <DeleteDialog
                {...{
                    open: restaurantInfoState.confirmDialogData.visible,
                    onCancel: () => { restaurantInfoState.confirmDialogData?.onCancel?.(); },
                    onConfirm: async () => { await restaurantInfoState.confirmDialogData?.handleClick?.(); },
                    onClose: () => {
                        if (restaurantInfoState.confirmDialogData?.onClose) {
                            restaurantInfoState.confirmDialogData?.onClose()
                        } else {
                            restaurantInfoState.confirmDialogData?.onCancel?.();
                        }
                    },
                    title: restaurantInfoState.confirmDialogData.title,
                    desc: restaurantInfoState.confirmDialogData.content,
                    cancelText: restaurantInfoState.confirmDialogData.cancelText,
                    confirmText: restaurantInfoState.confirmDialogData.confirmText
                }} />
            {/* GYB 弹窗 */}
            <ResellerGYBDialog
                {...{
                    open: restaurantInfoState.showGYBDialog.open,
                    onClose: () => { restaurantInfoState.showGYBDialog?.onClose?.(); },
                    onSaveCallback: (error) => { restaurantInfoState?.onSaveGYB?.(error); },
                    dialogType: restaurantInfoState.showGYBDialog?.dialogType,
                    restaurantInfo: restaurantInfoState.restaurantInfo,
                    GYBDeviceInfo: restaurantInfoState.showGYBDialog.GYBDeviceInfo,
                    GYBList: restaurantInfoState.GYBList
                }} />
            {/* 弹窗新增绑定负责人 绑定账号组件 */}
            <BindAccount
                // 弹窗控制
                configDialog={{
                    visible: restaurantInfoState.responsabileDialogData.visible,
                    title: restaurantInfoState.responsabileDialogData?.title ?? '',
                    onClose: restaurantInfoState.responsabileDialogData?.onClose
                }}
                // 弹窗配置数据
                dialogConfigData={{
                    type: 'RESTAURANT',
                    groupStringId: restaurantInfoState.groupId || '',
                    restaurantStringId: restaurantInfoState.restaurantInfo.string_id || '',
                    bindCallBack: async () => {
                        await restaurantInfoState.getRestaurantInfo();
                    }
                }}
            />
            {/* 核心文件日志 */}
            <RestaurantCoreFlieLogDialog
                open={restaurantInfoState.showCoreFlieLogDialog.open}
                onClose={() => restaurantInfoState.showCoreFlieLogDialog.onClose()}
                info={restaurantInfoState.showCoreFlieLogDialog.info!}
                onSave={(params) => restaurantInfoState.showCoreFlieLogDialog.onSave?.(params)}
                dialogType={restaurantInfoState.showCoreFlieLogDialog.dialogType}
            />
            {/* 预览协议弹窗 */}
            <PdfPreviewDialog
                open={restaurantInfoState.showPreviewAgreementDialog.open}
                onClose={() => restaurantInfoState.showPreviewAgreementDialog.onClose()}
                url={restaurantInfoState.showPreviewAgreementDialog.url}
            />
        </DialogComponent>
    )
})